import type { CSSProperties, JSX } from 'react'

import type { Icon } from '.'

export function Bag({ className, style }: Readonly<Icon>): JSX.Element {
  const styles: CSSProperties = {
    fill: 'none',
    stroke: '#000',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    strokeWidth: '45.67px',
    ...style,
  }

  return (
    <svg
      className={className}
      data-name="Layer 1"
      id="Layer_1"
      viewBox="0 0 3000 3000"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        height="1582.29"
        style={styles}
        width="1369.29"
        x="815.36"
        y="928.74"
      />
      <path
        d="m1165.29,928.74v-105.06c0-184.86,149.86-334.71,334.71-334.71s334.71,149.86,334.71,334.71v105.06"
        style={styles}
      />
    </svg>
  )
}

export default Bag
